import Vue from 'vue';
import lodash from 'lodash';
import moment from 'moment';

export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm';

export const DATE_TIME_LONG_FORMAT = "yyyy-MM-dd'T'HH:mm";
export const INSTANT_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSSZ";
export const ZONED_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXXXX";
export const MONTH_YEAR_ONLY = "MMM-YYYY"

function getLang()
{
  if (navigator.languages != undefined)
    return navigator.languages[0];
  else
    return navigator.language;
}

function replace(str){
  // replace left-to-right marks in IE
  return str.replace(/\u200E/g,'');
}

function toDate(date ){
  return typeof date === 'string' ? new Date(date) : date;
}

export function localizedDateTime(value) {
  if (value == null)
    return '';
  const dateTimeFormat = new Intl.DateTimeFormat(getLang(), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }).format;

  return replace(dateTimeFormat(toDate(value)));
}

export function period(value) {
  if (value ==  null)
    return '';

  return moment(String(value), INSTANT_FORMAT).format(MONTH_YEAR_ONLY);
}

export function initFilters() {
  Vue.filter('truncTextArray', function (queries) {
    if (queries) {
      return lodash.truncate(queries, {length: 50});
    }
  });
  Vue.filter('formatProduct', function (product) {
    if (product) {
      return product === 'Parallels Business Automation' ? 'Odin Business Automation': 'Odin Operation Automation'
    }
  });
  Vue.filter('reportPeriod', function (value) {
    return period(value);
  });
  Vue.filter('localizedDateTime', function (value) {
    return localizedDateTime(value);
  });
}
